export default {
  backendHost: process.env.REACT_APP_BACKEND_HOST || "/",
  socketioHost: process.env.REACT_APP_SOCKETIO_HOST || "/"
};
